/* -----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/
/**
 * @packageDocumentation
 * @module statusbar
 */
export * from './components';
export * from './defaults';
export * from './statusbar';
export * from './style/statusbar';
export * from './tokens';
//# sourceMappingURL=index.js.map